import '../../../Core/widget/TextAreaField.js';
import FormTab from '../../../SchedulerPro/widget/taskeditor/FormTab.js';
import '../../../Core/widget/NumberField.js';

/**
 * @module Gantt/widget/projecteditor/ProjectEditorAdvancedTab
 */

/**
 * A tab inside the {@link Gantt/widget/ProjectEditor project editor} showing the advanced options for a project.
 *
 * | Field ref           | Type                            | Weight | Description                                                                                                   |
 * |---------------------|---------------------------------|--------|---------------------------------------------------------------------------------------------------------------|
 * | `hoursPerDayField`  | {@link Core/widget/NumberField} | 100    | Shows a number field to edit the number of {@link Gantt/model/ProjectModel#field-hoursPerDay hours per day}   |
 * | `daysPerWeekField`  | {@link Core/widget/NumberField} | 200    | Shows a number field to edit the number of {@link Gantt/model/ProjectModel#field-daysPerWeek days per week}   |
 * | `daysPerMonthField` | {@link Core/widget/NumberField} | 300    | Shows a number field to edit the number of {@link Gantt/model/ProjectModel#field-daysPerMonth days per month} |
 *
 * @extends  SchedulerPro/widget/taskeditor/FormTab
 * @classtype ProjectEditorAdvancedTab
 */
export default class ProjectEditorAdvancedTab extends FormTab {

    static $name = 'ProjectEditorAdvancedTab';

    static type = 'projecteditoradvancedtab';

    static configurable = {
        title : 'L{advanced}',

        defaults : {
            localeClass : this,
            labelWidth  : '10em'
        },
        items : {
            hoursPerDayField : {
                label  : 'L{hoursPerDay}',
                weight : 100,
                type   : 'numberfield',
                name   : 'hoursPerDay',
                min    : 1,
                max    : 24
            },
            daysPerWeekField : {
                label  : 'L{daysPerWeek}',
                weight : 200,
                type   : 'numberfield',
                name   : 'daysPerWeek',
                min    : 1,
                max    : 7
            },
            daysPerMonthField : {
                label  : 'L{daysPerMonth}',
                weight : 300,
                type   : 'numberfield',
                name   : 'daysPerMonth',
                max    : 31,
                min    : 1
            }
        }
    };
}

// Register this widget type with its Factory
ProjectEditorAdvancedTab.initClass();
